<!-- @veltra/icons generated sha256:114c772c658f8671 gen:8 source:src/svg/normal/form-textarea.svg -->
<script setup lang="ts">
defineOptions({ name: 'FormTextarea' })
</script>
<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">
    <rect
      width="14"
      height="12"
      x="1"
      y="2"
      fill="none"
      stroke="currentColor"
      stroke-width="1.2"
      rx="1.5"
    />
    <path stroke="currentColor" stroke-linecap="round" stroke-width="1.2" d="M4 5.5h8m-8 3h5" />
  </svg>
</template>
